'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
export function useLightbox() {
  const $ = _c(2);
  const [index, setIndex] = useState(null);
  let t0;
  if ($[0] !== index) {
    t0 = {
      index,
      openIndex(index_0) {
        setIndex(index_0);
      },
      close() {
        return setIndex(null);
      }
    };
    $[0] = index;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

// Lazy load the entire Gallery component (includes lightbox logic)
export const Lightbox = dynamic(() => import('./Lightbox.client'), {
  ssr: false,
  loading: () => null // No loading indicator needed for modal
});